export interface FooterSlashCommand {
  slug: string;
  label: string;
  command: string;
}

export const FOOTER_SLASH_COMMANDS: FooterSlashCommand[] = [
  {
    slug: "start-backend",
    label: "Start backend",
    command: "fintheon start backend",
  },
  { slug: "frontend", label: "Start frontend dev", command: "bunx vite" },
  {
    slug: "install",
    label: "Install all deps",
    command:
      "bun install && cd frontend && bun install && cd ../backend-hono && bun install",
  },
  { slug: "build", label: "Build frontend", command: "bunx vite build" },
  {
    slug: "typecheck",
    label: "Typecheck backend",
    command: "cd backend-hono && bunx tsc --noEmit",
  },
];

export function resolveFooterSlashCommand(input: string): string | null {
  if (!input.startsWith("/")) return null;
  const slug = input.slice(1).trim().toLowerCase().replace(/\s+/g, "-");
  return (
    FOOTER_SLASH_COMMANDS.find(
      (item) =>
        item.slug === slug ||
        item.slug.replaceAll("-", "") === slug.replaceAll("-", ""),
    )?.command ?? null
  );
}

export function compactFooterPrompt(cwd: string): string {
  const parts = cwd.split("/").filter(Boolean);
  if (parts.length <= 1) return cwd;
  const tail = parts.slice(-2).join("/");
  return parts.length === 2 ? tail : `.../${tail}`;
}
